import type { ApplyCreditsRequest } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useApplyCredits(options?: UseMutationOptions<void, unknown, ApplyCreditsRequest>) {
  return useMutation(async ({ invoiceId, creditAmount }) => {
    const api = getPrivateApi();
    await api.applyCredits({ applyCreditsRequest: { invoiceId, creditAmount } });
  }, options);
}
